<template>
  <div id="Reports">
    <SovecoNavBar />
    <div class="reports_top_box">REPORT PDF</div>
    <div class="columns is-variable">
      <div class="column is-narrow">
        <div class="reports_top_box">
          <span>Mezzi</span>
        </div>
        <VueScrollTable
          :options="vehiclesOpts"
          :columns="vehiclesCols"
          :rows="vehiclesRows"
        />
      </div>
      <div class="column">
        <div class="columns">
          <div class="column is-narrow">
            <div class="field">
              <label class="label">Mezzo selezionato :</label>
              <div class="control">
                <input
                  disabled
                  class="input is-disabled"
                  type="text"
                  placeholder
                  :value="vehicleSel.targa"
                />
              </div>
            </div>
            <div class="field">
              <label class="label">Selezione Date :</label>
              <div class="control">
                <table class="sr_history_table">
                  <tr>
                    <td>
                      <div class="sr_history_table_label">Dal</div>
                    </td>
                    <td>
                      <date-picker
                        v-model="startData"
                        type="datetime"
                        value-type="YYYY-MM-DD HH:mm"
                        format="DD-MM-YYYY HH:mm"
                        confirm
                      ></date-picker>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div class="sr_history_table_label">Al</div>
                    </td>
                    <td>
                      <date-picker
                        v-model="endData"
                        type="datetime"
                        value-type="YYYY-MM-DD HH:mm"
                        format="DD-MM-YYYY HH:mm"
                        confirm
                      ></date-picker>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div v-if="startData >= endData">Controlla le date</div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="field">
              <label class="label">Filtri :</label>
              <Multiselect
                v-model="tagValues"
                tag-placeholder="Aggiungi filtro"
                placeholder="Cerca/aggiunge filtro"
                select-label="Premi return per selezionare"
                selected="Selezionato"
                deselect-label="Premi return per rimuovere"
                label="segnale"
                track-by="id"
                :options="tags"
                :multiple="true"
                :taggable="true"
                @tag="addTag"
              />
              <pre class="language-json"><code>{{ value }}</code></pre>
            </div>
            <label class="label">Reports disponibili :</label>
            <table class="report_table">
              <tr>
                <td colspan="4">Flotta</td>
              </tr>
              <tr class="is-vertical-center green">
                <td width="50px">
                  <button class="is-small" @click="doAction(1, true)">
                    PDF
                  </button>
                </td>
                <td width="60px">
                  <button class="is-small" @click="doAction(1, false)">
                    CSV
                  </button>
                </td>
                <td width="170px">Posizioni attuali</td>
                <td>
                  <OrderBar
                    :id="'pa'"
                    :order-el="paOB"
                    :order-dir="0"
                    :order-active="0"
                  />
                </td>
              </tr>
              <!-- <tr
                class="is-vertical-center"
                :class="[isDateWrong() ? '' : 'green', '']"
              >
                <td width="50px">
                  <button
                    class="is-small"
                    :disabled="isDateWrong()"
                    @click="doAction(2, true)"
                  >
                    PDF
                  </button>
                </td>
                <td width="60px">
                  <button
                    class="is-small"
                    :disabled="isDateWrong()"
                    @click="doAction(2, false)"
                  >
                    CSV
                  </button>
                </td>
                <td width="170px">Dettaglio ore guida</td>
                <td>
                  <OrderBar
                    :id="'dog'"
                    :order-el="dogOB"
                    :order-dir="0"
                    :order-active="0"
                  />
                </td>
              </tr> -->
              <tr
                class="is-vertical-center"
                :class="[isDateWrong() ? '' : 'green', '']"
              >
                <td width="50px">
                  <button
                    class="is-small"
                    :disabled="isDateWrong()"
                    @click="doAction(3, true)"
                  >
                    PDF
                  </button>
                </td>
                <td width="60px">
                  <button
                    class="is-small"
                    :disabled="isDateWrong()"
                    @click="doAction(3, false)"
                  >
                    CSV
                  </button>
                </td>
                <td width="170px">Sommario ore guida</td>
                <td>
                  <OrderBar
                    :id="'sog'"
                    :order-el="sogOB"
                    :order-dir="0"
                    :order-active="0"
                  />
                </td>
              </tr>
              <tr>
                <td colspan="4">Mezzo : {{ vehicleSel.targa }}</td>
              </tr>
              <tr
                class="is-vertical-center"
                :class="[
                  vehicleSel.cod === undefined || isDateWrong() ? '' : 'green',
                  '',
                ]"
              >
                <td width="50px">
                  <button
                    class="is-small"
                    :disabled="vehicleSel.cod === undefined || isDateWrong()"
                    @click="doAction(20, true)"
                  >
                    PDF
                  </button>
                </td>
                <td width="60px">
                  <button
                    class="is-small"
                    :disabled="vehicleSel.cod === undefined || isDateWrong()"
                    @click="doAction(20, false)"
                  >
                    CSV
                  </button>
                </td>
                <td width="170px">Dettaglio ore guida</td>
                <td></td>
              </tr>
              <tr
                class="is-vertical-center"
                :class="[
                  vehicleSel.cod === undefined || isDateWrong() ? '' : 'green',
                  '',
                ]"
              >
                <td width="50px">
                  <button
                    class="is-small"
                    :disabled="vehicleSel.cod === undefined || isDateWrong()"
                    @click="doAction(4, true)"
                  >
                    PDF
                  </button>
                </td>
                <td width="60px">
                  <button
                    class="is-small"
                    :disabled="vehicleSel.cod === undefined || isDateWrong()"
                    @click="doAction(4, false)"
                  >
                    CSV
                  </button>
                </td>
                <td width="170px">Storico</td>
                <td />
              </tr>
              <tr
                class="is-vertical-center"
                :class="[
                  vehicleSel.cod === undefined || isDateWrong() ? '' : 'green',
                  '',
                ]"
              >
                <td width="50px">
                  <button
                    class="is-small"
                    :disabled="vehicleSel.cod === undefined || isDateWrong()"
                    @click="doAction(5, true)"
                  >
                    PDF
                  </button>
                </td>
                <td width="60px">
                  <button
                    class="is-small"
                    :disabled="vehicleSel.cod === undefined || isDateWrong()"
                    @click="doAction(5, false)"
                  >
                    CSV
                  </button>
                </td>
                <td width="170px ">Viaggi</td>
                <td />
              </tr>

              <tr
                class="is-vertical-center"
                :class="[
                  vehicleSel.cod === undefined ||
                  isDateWrong() ||
                  !vehicleSel.flagCarburante
                    ? ''
                    : 'green',
                  '',
                ]"
              >
                <td width="50px">
                  <button
                    class="is-small"
                    :disabled="
                      vehicleSel.cod === undefined ||
                      isDateWrong() ||
                      !vehicleSel.flagCarburante
                    "
                    @click="doAction(7, true)"
                  >
                    PDF
                  </button>
                </td>
                <td width="60px">
                  <button
                    class="is-small"
                    :disabled="
                      vehicleSel.cod === undefined ||
                      isDateWrong() ||
                      !vehicleSel.flagCarburante
                    "
                    @click="doAction(7, false)"
                  >
                    CSV
                  </button>
                </td>
                <td width="170px ">Report Carburante</td>
                <td>
                  <span class="trigger"
                    >Saranno riconosciuti come rifornimento solo valori
                    superiori a litri :</span
                  >
                  <input
                    v-model="trigger"
                    class="input"
                    type="number"
                    min="10"
                    placeholder=""
                  />
                </td>
              </tr>

              <tr
                class="is-vertical-center"
                :class="[
                  vehicleSel.cod === undefined || isDateWrong() ? '' : 'green',
                  '',
                ]"
              >
                <td width="50px">
                  <button
                    class="is-small"
                    :disabled="vehicleSel.cod === undefined || isDateWrong()"
                    @click="doAction(6, true)"
                  >
                    PDF
                  </button>
                </td>
                <td width="60px" />
                <td width="170px">Grafico percorrenza</td>
                <td />
              </tr>
            </table>

            <div v-if="isLoading" class="spinner">
              <VueElementLoading
                :active="isLoading"
                spinner="ring"
                color="#0000FF"
              />
            </div>
          </div>
          <div class="column">
            <div id="pdf">
              <iframe id="pdfiframe" width="100%" height="100%" :src="uri" />
            </div>
            <button
              :disabled="doc === null"
              class="is-small"
              @click="doFullScreen"
            >
              Apri report
            </button>
            Se non compare il PDF in questa finestra usare il bottone "Apri
            Report"
          </div>
        </div>
      </div>
    </div>
    <modal
      name="report_fullscreen"
      :width="modalWidth"
      :height="modalHeight"
      :draggable="true"
    >
      <div>
        <div id="pdf_fs">
          <iframe id="pdfiframefs" width="600px" height="100%" :src="uri" />
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import { ServiceBus } from '../ServiceBus.js'
import VueScrollTable from './reusable/VueScrollTable.vue'
import OrderBar from './reusable/OrderBar.vue'
import Multiselect from 'vue-multiselect'
import jsPDF from 'jspdf'
import { UtilityMixin } from '../mixins/UtilityMixin.js'
import VueElementLoading from 'vue-element-loading'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/it'
export default {
  name: 'Reports',
  components: {
    VueScrollTable,
    Multiselect,
    OrderBar,
    VueElementLoading,
    DatePicker,
  },
  mixins: [UtilityMixin],
  data() {
    return {
      trigger: 100,
      modalHeight: 600,
      modalWidth: 600,
      isLoading: false,
      apiServer: '',
      data: [],
      bigdata: [],
      tags: [],
      tagValues: [],
      uri: '',
      selectAll: false,
      startData: '',
      endData: '',
      doc: null,
      auth: null,
      prefs: null,
      vehiclesRows: [],
      vehicleSel: {},
      errorDate: '',
      paOB: [
        {
          name: 'Targa',
          id: 0,
        },
        {
          name: 'Autista',
          id: 1,
        },
        {
          name: 'Data',
          id: 2,
        },
        {
          name: 'In Viaggio',
          id: 3,
        },
      ],
      dogOB: [
        {
          name: 'Targa',
          id: 0,
        },
        {
          name: 'Autista',
          id: 1,
        },
      ],
      sogOB: [
        {
          name: 'Targa',
          id: 0,
        },
        {
          name: 'Ore Pausa',
          id: 1,
        },
        {
          name: 'Ore Guida',
          id: 2,
        },
        {
          name: 'Km',
          id: 3,
        },
      ],
      vehiclesOpts: {
        id: 'RP01',
        isResizeable: false,
        isSelectable: true,
        cssContainer: 'vehicles_rp',
        cssHeader: 'vehicles_lh',
        cssBody: 'vehicles_l',
        cssRows: 'vehicles_l',
        order_col: 'targa',
      },
      vehiclesCols: [
        {
          id: 'targa',
          visible: true,
          f_type: '*',
          title: 'Targa',
          width: 75,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: '',
          order: 0,
          image: false,
        },
        {
          id: 'autista',
          visible: true,
          f_type: '*',
          title: 'Autista',
          width: 140,
          alignment_th: '',
          alignment_td: '',
          elastic: true,
          filter: '',
          order: 1,
          image: false,
        },
      ],
      pa_att: {
        id: '',
        orderDir: 0,
        orderItem: 0,
      },
      dog_att: {
        id: '',
        orderDir: 0,
        orderItem: 0,
      },
      sog_att: {
        id: '',
        orderDir: 0,
        orderItem: 0,
      },
      pSet: {},
    }
  },
  created() {
    const vm = this
    vm.prefs = JSON.parse(vm.$localStorage.get('prefs'))
    vm.auth = JSON.parse(vm.$localStorage.get('auth'))
  },
  mounted() {
    const vm = this
    vm.api_server = vm.getApiServer()
    ServiceBus.setApi(vm.api_server)
    ServiceBus.setAuth(vm.auth)
    if (vm.auth === null) {
      vm.$router.push({
        path: 'login',
      })
    }
    ServiceBus.$on('orderbar', (obj) => {
      if (obj.id == 'pa') {
        vm.pa_att = obj
      }
      if (obj.id == 'dog') {
        vm.dog_att = obj
      }
      if (obj.id == 'sog') {
        vm.sog_att = obj
      }
    })

    vm.$nextTick(function () {
      window.removeEventListener('resize', null)
      window.addEventListener('resize', vm.getWindowHeight)
      vm.getWindowHeight()
      vm.doGetVehicles()
      vm.doGetTags()
    })
  },
  methods: {
    colClick(id, col, item) {
      const vm = this
      if (id == 'RP01') {
        vm.doc = null //new jsPDF(vm.pSet.orientation, 'pt', vm.pSet.pageSize)
        vm.vehicleSel = item
        vm.vehicleSel.flagCarburante =
          item.sonda_1 === 'C' ||
          item.sonda_2 === 'C' ||
          item.sonda_3 === 'C' ||
          item.sonda_4 === 'C'
      }
    },
    isDateWrong() {
      const vm = this
      let wrongDate
      wrongDate = vm.isEmptyObject(vm.startData) || vm.isEmptyObject(vm.endData)
      if (!wrongDate) {
        wrongDate = vm.startData >= vm.endData
      } else {
        wrongDate = false
      }
      return wrongDate
    },
    async doGetVehicles() {
      const vm = this
      vm.isLoading = true
      vm.vehiclesRows = await ServiceBus._doGetVehicles()
      vm.isLoading = false
    },

    async doGetTags() {
      const vm = this
      vm.isLoading = true
      vm.tags = await ServiceBus._doGetTags()
      vm.isLoading = false
    },

    autoText(text, x, y, halign, valign) {
      const vm = this
      const FONT_ROW_RATIO = 1.15
      if (typeof x !== 'number' || typeof y !== 'number') {
        console.error(
          'The x and y parameters are required. Missing for the text: ',
          text
        )
      }
      let k = vm.doc.internal.scaleFactor
      let fontSize = vm.doc.internal.getFontSize() / k

      let splitRegex = /\r\n|\r|\n/g
      let splitText = null
      let lineCount = 1
      if (
        valign === 'middle' ||
        valign === 'bottom' ||
        halign === 'center' ||
        halign === 'right'
      ) {
        splitText = typeof text === 'string' ? text.split(splitRegex) : text
        lineCount = splitText.length || 1
      }
      // Align the top
      y += fontSize * (2 - FONT_ROW_RATIO)
      if (valign === 'middle') y -= (lineCount / 2) * fontSize * FONT_ROW_RATIO
      else if (valign === 'bottom') y -= lineCount * fontSize * FONT_ROW_RATIO
      if (halign === 'center' || halign === 'right') {
        let alignSize = fontSize
        if (halign === 'center') alignSize *= 0.5
        if (lineCount >= 1) {
          for (let iLine = 0; iLine < splitText.length; iLine++) {
            vm.doc.text(
              splitText[iLine],
              x - vm.doc.getStringUnitWidth(splitText[iLine]) * alignSize,
              y
            )
            y += fontSize
          }
          return
        }
        x -= vm.doc.getStringUnitWidth(text) * alignSize
      }
      vm.doc.text(text, x, y)
    },

    doFullScreen() {
      const vm = this
      window.open(vm.doc.output('bloburl'), '_blank')
    },
    async doAction(n_mode, isPDF) {
      const vm = this
      vm.doc = null
      let i
      if (vm.auth.tipo === 3) {
        let flag = false

        if (vm.startData < vm.auth.inizio) {
          vm.startData = vm.auth.inizio
          flag = true
        }
        if (vm.startData > vm.auth.fine) {
          vm.startData = vm.auth.inizio
          flag = true
        }
        if (vm.endData > vm.auth.fine) {
          vm.endData = vm.auth.fine
          flag = true
        }
        if (vm.endData < vm.auth.inizio) {
          vm.endData = vm.auth.fine
          flag = true
        }
        if (flag) {
          vm.$dialog
            .alert(
              'Questo utente è abilitato alla consultazione del periodo dal ' +
                vm.reverseDateSoloSolo(vm.auth.inizio) +
                ' al ' +
                vm.reverseDateSoloSolo(vm.auth.fine)
            )
            .then(function () {})
            .catch(function () {})
        }
      }

      vm.isLoading = true
      switch (n_mode) {
        case 1: // posizioni attuali
          vm.doGetLastPos(isPDF)
          break
        case 2: // dettaglio ore pausa guida
          vm.selectAll = true
          vm.bigdata = []
          for (i = 0; i < vm.vehiclesRows.length; i++) {
            await vm.doGetPosCalcBIS(vm.vehiclesRows[i], false)
          }
          if (isPDF) {
            vm.doPdfDettaglioAll()
          } else {
            vm.doCSVDettaglioAll()
          }
          break
        case 3: // sommario ore pausa guida
          vm.selectAll = true
          vm.bigdata = []
          for (i = 0; i < vm.vehiclesRows.length; i++) {
            await vm.doGetPosCalcBIS(vm.vehiclesRows[i], true)
          }
          vm.doPdfSommarioAll(isPDF)
          break

        case 4: // STORICO
          vm.selectAll = false
          await vm.doGetPos(vm.vehicleSel, isPDF)
          vm.doPdfStorico(isPDF)
          break

        case 5:
          vm.selectAll = false
          vm.doGetPosTrip(vm.vehicleSel, false, isPDF)
          break
        case 6:
          vm.selectAll = false
          vm.doGetPosTrip(vm.vehicleSel, true, isPDF)
          break
        case 7:
          vm.selectAll = false
          await vm.doGetPos(vm.vehicleSel, isPDF)
          await vm.doCalcCarburante()
          vm.doPdfCarburante(isPDF)
          break

        case 20: // dettaglio ore pausa guida
          vm.selectAll = false
          await vm.doGetPosCalcBIS(vm.vehicleSel, false)
          vm.doPdfDettaglioSingle(isPDF)
          break
      }
    },
    async doGetPosTrip(vobj, isGraph, isPDF) {
      const vm = this
      let start = vm.newDate(vm.startData).toMysqlString()
      let end = vm.newDate(vm.endData).toMysqlString()
      const rdata = await ServiceBus._doGetPos(
        vm.tagValues,
        vobj.cod,
        start,
        end
      )
      if (rdata.length < 1) {
        vm.$dialog.alert('Nessuna dato per questi criteri di selezione')
        vm.isLoading = false
        return
      }
      vm.data = []
      vm.data = vm.extractJourney(start, end, rdata)
      if (!isGraph) {
        vm.data = vm.calcJourneys(vm.data)
      }
      if (isGraph) {
        vm.printTripBars()
      } else {
        vm.doPdfViaggi(isPDF)
      }
    },

    async doGetLastPos(isPDF) {
      const vm = this
      const rdata = await ServiceBus._doGetLastPos()
      if (vm.checkTkn(rdata)) {
        vm.data = rdata
        for (let i = 0; i < vm.data.length; i++) {
          vm.data[i].autista = vm.getDriverName(vm.data[i])
          if (vm.data[i].mode == 0) {
            vm.data[i].pausa = ''
            vm.data[i].guida = vm.calcDeltaTime(vm.data[i].time)
          } else {
            vm.data[i].guida = ''
            vm.data[i].pausa = vm.calcDeltaTime(vm.data[i].time)
          }
        }
        vm.doPdfPaAttuali(isPDF)
      }
    },

    async doGetPosCalcBIS(vobj, isSummary) {
      const vm = this
      let start = vm.newDate(vm.startData)
      let end = vm.newDate(vm.endData)
      vm.data = []
      const rdata = await ServiceBus._doGetPosCalcBIS(vobj.cod, start, end)
      if (isSummary) {
        vm.data.push(vm.filterSommarioGuidaPausa(start, end, vobj.targa, rdata))
      } else {
        vm.data = vm.filterGuidaPausaBis(start, end, vobj.targa, rdata)
      }

      let totaleKm = 0
      let totaleMin = 0
      vm.data.map((entry) => {
        if (!entry.isPausa) {
          totaleKm += entry.km_guida
          totaleMin += entry.mn_guida
        }
      })

      if (vm.selectAll) {
        let obj = {}
        obj.targa = vobj.targa
        obj.cod = vobj.cod
        obj.nick = vobj.nick
        obj.data = vm.data
        vm.bigdata.push(obj)
      } else {
        vm.data.push({
          fine: '',
          idx: 0,
          idx_s: 0,
          inizio: '',
          km_guida: 'Totale ' + totaleKm,
          guida: vm.minToString(totaleMin),
        })
      }
    },

    ///**** originale
    findStart(idx) {
      let vm = this
      for (let i = idx; i < vm.data.length; i++) {
        if (vm.data[i].message.indexOf('START') >= 0) {
          if (vm.diffMin(vm.data[i].date, vm.data[idx].date) < 15) {
            return { date: vm.data[i].date, carb: vm.data[i].v0 }
          } else {
            return { date: vm.data[idx].date, carb: vm.data[idx].v0 }
          }
        }
      }
    },

    doCalcCarburante() {
      const vm = this
      let carbs = []
      let lastKm = 0
      // filtra i messaggi che hanno un messaggio
      vm.data = vm.data
        .map((i) => ({ ...i, v0: parseFloat(i.v0) }))
        .filter((it) => it.message.length > 0)
      vm.trigger = vm.trigger < 10 ? 10 : vm.trigger
      let dbg_tot = 0
      let tot_km = 0
      let delta_litri = 0
      let start_litri = vm.data[0].v0
      let start_date = vm.data[0].date

      let journeyFlag = false
      for (let i = 0; i < vm.data.length - 1; i++) {
        if (vm.data[i].message.indexOf('START') >= 0) {
          if (journeyFlag) {
            tot_km = tot_km + lastKm
            lastKm = 0
          }
          journeyFlag = true
        }
        if (
          vm.data[i].message.indexOf('(STOP)') >= 0 &&
          vm.data[i].message.indexOf('(COUNTER)')
        ) {
          tot_km = tot_km + vm.data[i].km
          dbg_tot = dbg_tot + vm.data[i].km
          journeyFlag = false
        }
        if (vm.data[i].km > 0) {
          lastKm = vm.data[i].km
        }
        delta_litri = vm.data[i].v0 - vm.data[i + 1].v0

        // rifornimento
        if (delta_litri < 0 && Math.abs(delta_litri) > vm.trigger) {
          carbs.push({
            start: start_date,
            end: vm.data[i].date,
            carb_start: start_litri,
            carb_end: vm.data[i].v0,
            carb: Math.round(start_litri - vm.data[i].v0),
            tot_km: tot_km,
            label: 'consumi',
          })

          tot_km = 0
          start_date = vm.data[i + 1].date
          start_litri = vm.data[i + 1].v0

          carbs.push({
            start: start_date,
            end: '',
            carb_start: '',
            carb_end: '',
            carb: Math.round(vm.data[i + 1].v0 - vm.data[i].v0),
            tot_km: '',
            label: 'rifornimento',
          })
        }
      }
      carbs.push({
        start: start_date,
        end: vm.data[vm.data.length - 1].date,
        carb_start: start_litri,
        carb_end: vm.data[vm.data.length - 1].v0,
        carb: Math.round(start_litri - vm.data[vm.data.length - 1].v0),
        tot_km: tot_km,
        label: 'consumi',
      })
      vm.data = carbs
    },

    async doGetPos(vobj, isPDF) {
      const vm = this
      let start = vm.newDate(vm.startData).toMysqlString()
      let end = vm.newDate(vm.endData).toMysqlString()
      const rdata = await ServiceBus._doGetPos(
        vm.tagValues,
        vobj.cod,
        start,
        end
      )
      if (rdata.length < 1) {
        vm.$dialog.alert('Nessuna dato per questi criteri di selezione')
        vm.isLoading = false
        return
      }

      let kmmn = null
      let isKft = true
      let isTeltonika = false

      for (let i = 0; i < rdata.length; i++) {
        if (rdata[i].message.indexOf('Trip Start') >= 0) {
          isKft = false
          isTeltonika = true
          break
        }
      }
      if (isKft) {
        var delta = 0
        for (let i = 0; i < rdata.length; i++) {
          let element = rdata[i]

          if (element.message.length > 0) {
            let prev = i > 0 ? rdata[i - 1] : null
            let succ = i < rdata.length - 1 ? rdata[i + 1] : null
            vm.guessSonde34(element, succ, prev)
            /*
           if (prev) {
              if (prev.message.length > 0) {
                prev.delta = 1000
              } else {
                prev.delta = Math.abs(vm.diffMin(element.date, prev.date) * 60)
              }
            }
            if (succ) {
              if (succ.message.length > 0) {
                succ.delta = 1000
              } else {
                succ.delta = Math.abs(vm.diffMin(succ.date, element.date) * 60)
              }
            }
            if (succ && prev) {
              if (succ.delta < prev.delta) {
                element.v3 = succ.v3
                element.v4 = succ.v4
              } else {
                element.v3 = prev.v3
                element.v4 = prev.v4
              }
            } else {
              if (prev == null) {
                if (succ) {
                  element.v3 = succ.v3
                  element.v4 = succ.v4
                }
              }
              if (succ == null) {
                if (prev) {
                  element.v3 = prev.v3
                  element.v4 = prev.v4
                }
              }
            }
            */
          }
          element.km = ''
          element.mn = ''
          if (element.message.indexOf('COUNTER') >= 0) {
            kmmn = vm.extractKmMessage(element.message)
            if (kmmn) {
              element.km = kmmn.km
              if (isPDF) {
                element.mn = vm.minuti2hour(kmmn.mn)
              } else {
                element.mn = kmmn.mn
              }
              kmmn = null
            }
          }
        }
        // rdata.forEach((element) => {
        //   element.km = ''
        //   element.mn = ''
        //   if (element.message.indexOf('(STOP)') >= 0) {
        //     kmmn = vm.extractKmMessage(element.message)
        //   } else if (element.message.indexOf('STOP[') >= 0) {
        //     if (kmmn) {
        //       element.km = kmmn.km
        //       if (isPDF) {
        //         element.mn = vm.minuti2hour(kmmn.mn)
        //       } else {
        //         element.mn = kmmn.mn
        //       }
        //       kmmn = null
        //     }
        //   }
        // })
      }
      /*
      if (isTeltonika) {
        let km_start
        let km_stop
        let date_start = null


        rdata.forEach((element) => {
          if (element.message.indexOf('Trip Start') >= 0) {
            km_start = Math.round(parseInt(element.message.split(':')[1]) / 10)
            date_start = element.date
          }
          if (element.message.indexOf('Trip End') >= 0) {
            if (date_start) {
              km_stop = Math.round(parseInt(element.message.split(':')[1]) / 10)
              element.mn = Math.round(vm.diffMin(element.date, date_start))
              element.km = Math.round(km_stop - km_start)
            } else {
              element.km = ''
              element.mn = ''
            }
            date_start = null
          }
        })
      }
    */
      if (isTeltonika) {
        let kmStart = null
        let dateStart = null

        rdata.forEach((element) => {
          const { message, date } = element

          if (message.includes('Trip Start')) {
            kmStart = Math.round(parseInt(message.split(':')[1], 10))
            dateStart = date
          }

          if (message.includes('Trip End')) {
            if (dateStart !== null && kmStart !== null) {
              let kmStop = Math.round(parseInt(message.split(':')[1], 10))
              element.mn = Math.round(vm.diffMin(date, dateStart))
              element.km = Math.round(kmStop - kmStart)
            } else {
              element.km = ''
              element.mn = ''
            }

            // Reset start values for the next trip
            kmStart = null
            dateStart = null
          }
        })
      }
      vm.data = rdata
    },

    doPdfSommarioAll(isPDF) {
      let vm = this
      let header = ['Targa', 'Ore Pausa', 'Ore Guida', 'KM']
      let cols = [
        {
          l: 'Targa',
          k: 'targa',
          w: 100,
          f: 10,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'Ore Pausa',
          k: 'pausa_str',
          w: 80,
          f: 0,
          r: 0,
          b: -1,
          c: 0,
        },
        {
          l: 'Ore Guida',
          k: 'guida_str',
          w: 80,
          f: 0,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'KM',
          k: 'km',
          w: 80,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        },
      ]
      vm.pSet.cols = cols
      vm.sortSogList()
      //vm.doc = new jsPDF(vm.pSet.orientation, "pt", vm.pSet.pageSize);
      vm.pSet.pageSize = 'a4'
      vm.pSet.fontSize = 9
      vm.pSet.title_fontSize = 12
      vm.pSet.marginTop = 35
      vm.pSet.marginLeft = 20
      vm.pSet.marginBottom = 30
      vm.pSet.verIncr = 16
      vm.pSet.verPos = 0
      vm.pSet.horPos = 0
      vm.pSet.mRow = 0
      vm.pSet.multipleRow = 0
      vm.pSet.title =
        'Sommario ore Guida/Pausa/Km : ' +
        vm.reverseDate(vm.startData) +
        ' - ' +
        vm.reverseDate(vm.endData)
      vm.pSet.cols = cols
      vm.pSet.rowType = 0

      vm.data = vm.flattenBigdata(vm.bigdata)

      if (isPDF) {
        vm.printerMachine()
      } else {
        vm.csvMachine('sommario_ore_guida_pausa.csv', header)
      }
    },
    doCSVDettaglioAll() {
      const vm = this
      let header = ['Targa', 'Inizio', 'Fine', 'Guida', 'Pausa', 'KM']
      let cols = [
        {
          l: 'Targa',
          k: 'targa',
          w: 90,
          f: 1,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'Inizio',
          k: 'inizio',
          w: 90,
          f: 1,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'Fine',
          k: 'fine',
          w: 90,
          f: 1,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'Guida',
          k: 'guida',
          w: 60,
          f: 0,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'Pausa',
          k: 'pausa',
          w: 60,
          f: 0,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'KM',
          k: 'km_guida',
          w: 60,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        },
      ]
      vm.pSet.rowType = 0
      vm.pSet.cols = cols
      vm.data = vm.flattenBigdata(vm.bigdata)
      vm.csvMachine('dettaglio_ore_pausa_guida_flotta.csv', header)
      vm.isLoading = false
    },
    doPdfDettaglioAll() {
      const vm = this
      let cols = [
        {
          l: 'Inizio',
          k: 'inizio',
          w: 90,
          f: 1,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'Fine',
          k: 'fine',
          w: 90,
          f: 1,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'Guida',
          k: 'guida',
          w: 60,
          f: 0,
          r: 0,
          b: -1,
        },
        {
          l: 'Pausa',
          k: 'pausa',
          w: 60,
          f: 0,
          r: 0,
          b: -1,
        },
        {
          l: 'KM',
          k: 'km_guida',
          w: 60,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        },
      ]
      vm.pSet.cols = cols
      vm.doc = new jsPDF(vm.pSet.orientation, 'pt', vm.pSet.pageSize)
      vm.pSet.width = vm.doc.internal.pageSize.getWidth()
      vm.pSet.height = vm.doc.internal.pageSize.getHeight()
      vm.sortBigdata()
      let start = vm.newDate(vm.startData).toMysqlString()
      let end = vm.newDate(vm.endData).toMysqlString()

      for (let i = 0; i < vm.bigdata.length; i++) {
        vm.pSet.orientation = 'p'
        vm.pSet.pageSize = 'a4'
        vm.pSet.fontSize = 9
        vm.pSet.title_fontSize = 12
        vm.pSet.marginTop = 35
        vm.pSet.marginLeft = 20
        vm.pSet.marginBottom = 30
        vm.pSet.verIncr = 16
        vm.pSet.verPos = vm.pSet.marginTop
        vm.pSet.horPos = vm.pSet.marginLeft
        vm.pSet.mRow = 0
        vm.pSet.multipleRow = 0
        vm.pSet.title =
          'Ore guida / pausa : ' +
          vm.bigdata[i].targa +
          '  ' +
          vm.reverseDate(start) +
          ' - ' +
          vm.reverseDate(end)

        vm.printTitle()
        vm.doc.setFontSize(vm.pSet.fontSize)
        vm.printHeader()
        for (let x = 0; x < vm.bigdata[i].data.length; x++) {
          vm.printRow(vm.bigdata[i].data[x])
          vm.incrLine()
        }
        if (i + 1 !== vm.bigdata.length) {
          vm.doc.addPage()
        }
      }
      vm.uri = vm.doc.output('datauristring')
      vm.isLoading = false
    },
    doPdfDettaglioSingle(isPDF) {
      const vm = this
      let header = ['Inizio', 'Fine', 'Guida', 'Pausa', 'KM']
      let cols = [
        {
          l: 'Inizio',
          k: 'inizio',
          w: 90,
          f: 1,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'Fine',
          k: 'fine',
          w: 90,
          f: 1,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'Guida',
          k: 'guida',
          c: 0,
          w: 60,
          f: 0,
          r: 0,
          b: -1,
        },
        {
          l: 'Pausa',
          k: 'pausa',
          c: 0,
          w: 60,
          f: 0,
          r: 0,
          b: -1,
        },
        {
          l: 'KM',
          k: 'km_guida',
          w: 60,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        },
      ]
      let start = vm.newDate(vm.startData).toMysqlString()
      let end = vm.newDate(vm.endData).toMysqlString()
      vm.pSet.orientation = 'p'
      vm.pSet.pageSize = 'a4'
      vm.pSet.fontSize = 9
      vm.pSet.title_fontSize = 12
      vm.pSet.marginTop = 35
      vm.pSet.marginLeft = 20
      vm.pSet.marginBottom = 30
      vm.pSet.verIncr = 16
      vm.pSet.verPos = 0
      vm.pSet.horPos = 0
      vm.pSet.mRow = 0
      vm.pSet.multipleRow = 0
      vm.pSet.title =
        'Ore guida / pausa : ' +
        vm.vehicleSel.targa +
        '  ' +
        vm.reverseDate(start) +
        ' - ' +
        vm.reverseDate(end)
      vm.pSet.cols = cols
      vm.pSet.rowType = 0
      if (isPDF) {
        vm.printerMachine()
      } else {
        vm.csvMachine(
          'dettaglio_ore_guida_' + vm.vehicleSel.targa + '.csv',
          header
        )
      }
    },
    doPdfStorico(isPDF) {
      const vm = this
      let col
      let header = [
        'Data',
        'Posizione',
        'Lat.',
        'Lon.',
        'KM/h',
        'Messaggio',
        'KM',
        'Min',
      ]
      let start = vm.newDate(vm.startData).toMysqlString()
      let end = vm.newDate(vm.endData).toMysqlString()
      let cols = [
        {
          l: 'Data',
          k: 'date',
          w: 90,
          f: 1,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'Posizione',
          k: 'address',
          w: 300,
          f: 3,
          r: 0,
          b: 0,
          c: 0,
        },
        {
          l: 'Lat',
          k: 'latitude',
          w: 40,
          f: 12,
          c: 0,
          r: 0,
          b: 0,
        },
        {
          l: 'Lon',
          k: 'longitude',
          w: 40,
          f: 12,
          c: 0,
          r: 0,
          b: 0,
        },
        {
          l: 'Km/h',
          k: 'speed',
          w: 30,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'Messaggio',
          k: 'message',
          w: 50,
          f: 2,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'KM',
          k: 'km',
          w: 40,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'Min',
          k: 'mn',
          w: 40,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        },
      ]
      if (
        vm.auth.sonde.c1 +
          vm.auth.sonde.c2 +
          vm.auth.sonde.c3 +
          vm.auth.sonde.c4 >
        1
      ) {
        col = {
          l: 'Tot.',
          k: 'v0',
          w: 40,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        }
        cols.push(col)
      }
      let c = 0
      let t = 0
      if (vm.vehicleSel.sonda_1 === 'C') {
        c++
        col = {
          l: 'C.',
          k: 'v1',
          w: 45,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        }
        cols.push(col)
      }
      if (vm.vehicleSel.sonda_2 === 'C') {
        c++
        col = {
          l: 'C.',
          k: 'v2',
          w: 50,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        }
        cols.push(col)
      }
      if (vm.vehicleSel.sonda_3 === 'C') {
        c++
        col = {
          l: 'C.',
          k: 'v3',
          w: 50,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        }
        cols.push(col)
      }
      if (vm.vehicleSel.sonda_4 === 'C') {
        c++
        col = {
          l: 'C.',
          k: 'v4',
          w: 50,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        }
        cols.push(col)
      }
      if (vm.vehicleSel.sonda_1 === 'T') {
        t++
        col = {
          l: 'T ',
          k: 'v1',
          w: 50,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        }
        cols.push(col)
      }
      if (vm.vehicleSel.sonda_2 === 'T') {
        t++
        col = {
          l: 'T ',
          k: 'v2',
          w: 50,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        }
        cols.push(col)
      }
      if (vm.vehicleSel.sonda_3 === 'T') {
        t++
        col = {
          l: 'T ',
          k: 'v3',
          w: 50,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        }
        cols.push(col)
      }
      if (vm.vehicleSel.sonda_3 === 'T') {
        t++
        col = {
          l: 'T ',
          k: 'v4',
          w: 50,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        }
        cols.push(col)
      }
      if (vm.vehicleSel.sonda_1 === 'V') {
        t++
        col = {
          l: 'T ',
          k: 'v1',
          w: 50,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        }
        cols.push(col)
      }
      if (vm.vehicleSel.sonda_2 === 'V') {
        t++
        col = {
          l: 'T ',
          k: 'v2',
          w: 50,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        }
        cols.push(col)
      }
      if (vm.vehicleSel.sonda_3 === 'V') {
        t++
        col = {
          l: 'T ',
          k: 'v3',
          w: 50,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        }
        cols.push(col)
      }
      if (vm.vehicleSel.sonda_4 === 'V') {
        t++
        col = {
          l: 'T ',
          k: 'v4',
          w: 50,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        }
        cols.push(col)
      }
      cols.push({
        l: '',
        k: 'address',
        w: 300,
        f: 3,
        c: 1,
        r: 1,
        b: 1,
      })
      vm.pSet.orientation = 'l'
      vm.pSet.pageSize = 'a4'
      vm.pSet.fontSize = 9
      vm.pSet.title_fontSize = 12
      vm.pSet.marginTop = 35
      vm.pSet.marginLeft = 20
      vm.pSet.marginBottom = 30
      vm.pSet.verIncr = 16
      vm.pSet.verPos = 0
      vm.pSet.horPos = 0
      vm.pSet.mRow = 0
      vm.pSet.multipleRow = 0
      vm.pSet.title =
        'Storico : ' +
        vm.vehicleSel.targa +
        ' ' +
        vm.reverseDate(start) +
        ' - ' +
        vm.reverseDate(end)
      vm.pSet.cols = cols
      vm.pSet.rowType = 0
      if (isPDF) {
        vm.printerMachine()
      } else {
        vm.csvMachine('storico_' + vm.vehicleSel.targa + '.csv', header)
      }
    },
    doPdfCarburante(isPDF) {
      const vm = this
      let col
      let header = [
        'Inizio',
        'Litri',
        'Fine.',
        'Litri',
        'Descrizione',
        'Litri',
        'Km',
      ]
      let start = vm.newDate(vm.startData).toMysqlString()
      let end = vm.newDate(vm.endData).toMysqlString()
      let cols = [
        {
          l: 'Data',
          k: 'start',
          w: 90,
          f: 1,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'Litri',
          k: 'carb_start',
          w: 40,
          f: 12,
          c: 0,
          r: 0,
          b: 0,
        },
        {
          l: 'Data',
          k: 'end',
          w: 90,
          f: 1,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'Litri',
          k: 'carb_end',
          w: 40,
          f: 12,
          c: 0,
          r: 0,
          b: 0,
        },
        {
          l: 'Descrizione',
          k: 'label',
          w: 70,
          f: 2,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'Litri',
          k: 'carb',
          w: 40,
          f: 12,
          c: 0,
          r: 0,
          b: 0,
        },
        {
          l: 'Km',
          k: 'tot_km',
          w: 40,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        },
      ]

      vm.pSet.orientation = 'p'
      vm.pSet.pageSize = 'a4'
      vm.pSet.fontSize = 9
      vm.pSet.title_fontSize = 12
      vm.pSet.marginTop = 35
      vm.pSet.marginLeft = 20
      vm.pSet.marginBottom = 30
      vm.pSet.verIncr = 16
      vm.pSet.verPos = 0
      vm.pSet.horPos = 0
      vm.pSet.mRow = 0
      vm.pSet.multipleRow = 0
      vm.pSet.title =
        'Carburante ' +
        vm.vehicleSel.targa +
        '( rifornimento > ' +
        vm.trigger +
        ' Litri ) : ' +
        vm.reverseDate(start) +
        ' - ' +
        vm.reverseDate(end)
      vm.pSet.cols = cols
      vm.pSet.rowType = 0
      if (isPDF) {
        vm.printerMachine()
      } else {
        vm.csvMachine('carburante_' + vm.vehicleSel.targa + '.csv', header)
      }
    },
    doPdfViaggi(isPDF) {
      const vm = this
      let start = vm.newDate(vm.startData).toMysqlString()
      let end = vm.newDate(vm.endData).toMysqlString()
      let header = ['Inizio', 'Posizione', 'Fine', 'Posizione', 'Tempo', 'KM']
      vm.pSet.orientation = 'l'
      vm.pSet.pageSize = 'a4'
      vm.pSet.fontSize = 9
      vm.pSet.title_fontSize = 12
      vm.pSet.marginTop = 35
      vm.pSet.marginLeft = 20
      vm.pSet.marginBottom = 30
      vm.pSet.verIncr = 16
      vm.pSet.verPos = 0
      vm.pSet.horPos = 0
      vm.pSet.mRow = 0
      vm.pSet.multipleRow = 0
      vm.pSet.title =
        'Storico Viaggi : ' +
        vm.reverseDate(start) +
        ' - ' +
        vm.reverseDate(end)
      vm.pSet.rowType = 1
      if (isPDF) {
        vm.printerMachine()
      } else {
        vm.csvMachine('storico_viaggi_' + vm.vehicleSel.targa + '.csv', header)
      }
    },

    doPdfPaAttuali(isPDF) {
      const vm = this
      let header = [
        'Targa',
        'Data',
        'Posizione',
        'Guida',
        'Pausa',
        'Km/h',
        'GPS',
        'Messaggio',
      ]
      let cols = [
        {
          l: 'Targa',
          k: 'targa',
          w: 55,
          f: 0,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'Data',
          k: 'date',
          w: 90,
          f: 1,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: '',
          k: 'address',
          w: 350,
          f: 3,
          c: 0,
          r: 0,
          b: 0,
        },

        {
          l: 'Guida',
          k: 'guida',
          w: 55,
          f: 0,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'Pausa',
          k: 'pausa',
          w: 55,
          f: 0,
          c: 0,
          r: 0,
          b: -1,
        },
        {
          l: 'Km/h',
          k: 'speed',
          w: 33,
          f: 12,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'GPS',
          k: 'gps',
          w: 33,
          f: 11,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: 'Messaggio',
          k: 'message',
          w: 135,
          f: 2,
          r: 0,
          c: 0,
          b: -1,
        },
        {
          l: '',
          k: 'address',
          w: 350,
          f: 3,
          c: 2,
          r: 1,
          b: 1,
        },
        {
          l: 'Autista/Posizione',
          k: 'autista',
          w: 350,
          f: 0,
          c: 2,
          r: 2,
          b: -1,
        },
      ]
      vm.pSet.orientation = 'l'
      vm.pSet.pageSize = 'a4'
      vm.pSet.fontSize = 9
      vm.pSet.title_fontSize = 12
      vm.pSet.marginTop = 35
      vm.pSet.marginLeft = 20
      vm.pSet.marginBottom = 30
      vm.pSet.verIncr = 16
      vm.pSet.verPos = 0
      vm.pSet.horPos = 0
      vm.pSet.mRow = 0
      vm.pSet.multipleRow = 0
      vm.pSet.title = 'Posizioni attuali : ' + vm.currentDate()
      vm.pSet.cols = cols
      vm.sortPaAttualiList()
      vm.pSet.rowType = 0
      if (isPDF) {
        vm.printerMachine()
      } else {
        vm.csvMachine('posizioni_attuali.csv', header)
      }
    },
    sortPaAttualiList() {
      const vm = this
      if (vm.pa_att.orderDir < 1) {
        switch (vm.pa_att.orderItem) {
          case 0:
            vm.data.sort(this.sortForTargaAsc)
            break
          case 1:
            vm.data.sort(this.sortForDriverAsc)
            break
          case 2:
            vm.data.sort(this.sortForDateAsc)
            break
          case 3:
            vm.data.sort(this.sortForModeAsc)
            break
        }
      } else {
        switch (vm.pa_att.orderItem) {
          case 0:
            vm.data.sort(this.sortForTargaDesc)
            break
          case 1:
            vm.data.sort(this.sortForDriverDesc)
            break
          case 2:
            vm.data.sort(this.sortForDateDesc)
            break
          case 3:
            vm.data.sort(this.sortForModeDesc)
            break
        }
      }
    },
    sortSogList() {
      const vm = this
      if (vm.sog_att.orderDir < 1) {
        switch (vm.sog_att.orderItem) {
          case 0:
            vm.data.sort(vm.sortForTargaSsc)
            break
          case 1:
            vm.data.sort(vm.sortForPausaSsc)
            break
          case 2:
            vm.data.sort(vm.sortForGuidaAsc)
            break
          case 3:
            vm.data.sort(vm.sortForKmAsc)
            break
        }
      } else {
        switch (vm.sog_att.orderItem) {
          case 0:
            vm.data.sort(vm.sortForTargaDesc)
            break
          case 1:
            vm.data.sort(vm.sortForPausaDesc)
            break
          case 2:
            vm.data.sort(vm.sortForGuidaDesc)
            break
          case 3:
            vm.data.sort(vm.sortForKmDesc)
            break
        }
      }
    },
    sortBigdata() {
      const vm = this
      if (vm.dog_att.orderDir < 1) {
        switch (vm.dog_att.orderItem) {
          case 0:
            vm.bigdata.sort(this.sortForTargaAsc)
            break
          case 1:
            vm.bigdata.sort(this.sortForDriverAsc)
            break
        }
      } else {
        switch (vm.dog_att.orderItem) {
          case 0:
            vm.bigdata.sort(this.sortForTargaDesc)
            break
          case 1:
            vm.bigdata.sort(this.sortForDriverDesc)
            break
        }
      }
    },
    printCSVRow(row) {
      const vm = this
      let s = ''
      let a

      let csvContent = ''

      for (let i = 0; i < vm.pSet.cols.length; i++) {
        s = ''
        if (vm.pSet.cols[i].c >= 0 && vm.pSet.cols[i].r === 0) {
          s = row[vm.pSet.cols[i].k]

          //========== sondenull
          if (
            vm.pSet.cols[i].k === 'v0' ||
            vm.pSet.cols[i].k === 'v1' ||
            vm.pSet.cols[i].k === 'v2' ||
            vm.pSet.cols[i].k === 'v3' ||
            vm.pSet.cols[i].k === 'v4'
          ) {
            a = parseFloat(s)
            s = vm.$options.filters.sondenull_filter(a) + ''
          }
          //=============
          //console.log('s ', s)
          if (s === null || s === undefined) s = ''
          s = s.toString()
          // operazioni sulla stringa
          switch (vm.pSet.cols[i].f) {
            case 1:
              s = vm.reverseDate(s)
              break
            case 2:
              s = s.split('[')[0]
              break
            case 3:
              s = s.replace(/\|/g, ' ')
              break
          }
          if (i > 0) {
            csvContent += ';'
          }
          csvContent += s
        }
      }
      csvContent += '\r\n'
      return csvContent
    },
    printCSVTripRow(row) {
      const vm = this
      let csvContent = vm.reverseDate(row.inizio)
      csvContent += ';'
      csvContent += row.obj_s.address.replace(/\|/g, ' ')
      csvContent += ';'
      csvContent += vm.reverseDate(row.fine)
      csvContent += ';'
      csvContent += row.obj_e.address.replace(/\|/g, ' ')
      csvContent += ';'
      csvContent += vm.minToString(row.minuti)
      csvContent += ';'
      csvContent += row.km.toString()
      csvContent += '\r\n'
      return csvContent
    },
    printTripRow(row) {
      const vm = this
      vm.autoText('INIZIO', vm.pSet.horPos + 2, vm.pSet.verPos, 'left', 'top')
      vm.pSet.horPos += 50
      vm.autoText(
        vm.reverseDate(row.inizio),
        vm.pSet.horPos + 2,
        vm.pSet.verPos,
        'left',
        'top'
      )
      vm.pSet.horPos += 100
      vm.autoText(
        row.obj_s.address.replace(/\|/g, ' '),
        vm.pSet.horPos + 2,
        vm.pSet.verPos,
        'left',
        'top'
      )
      vm.incrLine()
      vm.autoText('FINE', vm.pSet.horPos + 2, vm.pSet.verPos, 'left', 'top')
      vm.pSet.horPos += 50
      vm.autoText(
        vm.reverseDate(row.fine),
        vm.pSet.horPos + 2,
        vm.pSet.verPos,
        'left',
        'top'
      )
      vm.pSet.horPos += 100
      vm.autoText(
        row.obj_e.address.replace(/\|/g, ' '),
        vm.pSet.horPos + 2,
        vm.pSet.verPos,
        'left',
        'top'
      )
      vm.incrLine()
      vm.autoText('DURATA', vm.pSet.horPos + 2, vm.pSet.verPos, 'left', 'top')
      vm.pSet.horPos += 50
      vm.autoText(
        vm.minToString(row.minuti),
        vm.pSet.horPos + 2,
        vm.pSet.verPos,
        'left',
        'top'
      )
      vm.pSet.horPos += 100
      vm.autoText('Km', vm.pSet.horPos + 2, vm.pSet.verPos, 'left', 'top')
      vm.pSet.horPos += 30
      vm.autoText(
        row.km.toString(),
        vm.pSet.horPos + 2,
        vm.pSet.verPos,
        'left',
        'top'
      )
      vm.incrLine()
    },
    printRow(row) {
      const vm = this
      let s = ''
      let a
      vm.pSet.horPos = vm.pSet.marginLeft
      vm.pSet.multipleRow = 0
      for (let i = 0; i < vm.pSet.cols.length; i++) {
        s = row[vm.pSet.cols[i].k]
        if (s === null || s === undefined) s = ''

        //========== sondenull
        if (
          vm.pSet.cols[i].k === 'v0' ||
          vm.pSet.cols[i].k === 'v1' ||
          vm.pSet.cols[i].k === 'v2' ||
          vm.pSet.cols[i].k === 'v3' ||
          vm.pSet.cols[i].k === 'v4'
        ) {
          a = parseFloat(s)
          s = vm.$options.filters.sondenull_filter(a) + ''
        }
        //==========

        s = s.toString()
        // operazioni sulla stringa
        switch (vm.pSet.cols[i].f) {
          case 1:
            s = vm.reverseDate(s)
            break
          case 2:
            s = s.split('[')[0]
            break
          case 3:
            s = s.replace(/\|/g, ' ')
            break
        }
        if (vm.pSet.cols[i].b >= 0) {
          a = vm.doc.splitTextToSize(s, vm.pSet.cols[i].w - 4)
          if (a.length > 0 && a.length > vm.pSet.cols[i].b) {
            s = a[vm.pSet.cols[i].b]
          } else {
            s = ''
          }
        }
        if (s.length > 0) {
          if (vm.pSet.cols[i].r != vm.pSet.multipleRow) {
            vm.incrLine()
            vm.pSet.multipleRow = vm.pSet.cols[i].r
            for (let x = 0; x < vm.pSet.cols[i].c; x++) {
              vm.pSet.horPos += vm.pSet.cols[x].w
            }
          }
          if (vm.pSet.cols[i].f > 9) {
            switch (vm.pSet.cols[i].f) {
              case 10:
                vm.autoText(
                  s,
                  vm.pSet.horPos + 2,
                  vm.pSet.verPos,
                  'left',
                  'top'
                )
                break
              case 11:
                vm.autoText(
                  s,
                  vm.pSet.horPos + vm.pSet.cols[i].w / 2,
                  vm.pSet.verPos,
                  'center',
                  'top'
                )
                break
              case 12:
                vm.autoText(
                  s,
                  vm.pSet.horPos + vm.pSet.cols[i].w - 2,
                  vm.pSet.verPos,
                  'right',
                  'top'
                )
                break
            }
          } else {
            vm.autoText(s, vm.pSet.horPos + 2, vm.pSet.verPos, 'left', 'top')
          }
        }
        vm.pSet.horPos += vm.pSet.cols[i].w
      }
    },
    incrLine() {
      const vm = this
      vm.pSet.verPos += vm.pSet.verIncr
      vm.pSet.horPos = vm.pSet.marginLeft
      if (
        vm.pSet.verPos + vm.pSet.verIncr >
        vm.pSet.height - vm.pSet.marginBottom
      ) {
        vm.doc.addPage()
        vm.pSet.verPos = vm.pSet.marginTop
        vm.printHeader()
      }
    },
    printTitle() {
      const vm = this
      vm.doc.setFontSize(vm.pSet.title_fontSize)
      vm.doc.text(vm.pSet.title, vm.pSet.horPos, vm.pSet.verPos)
      vm.pSet.verPos += 25
    },
    printHeader() {
      const vm = this
      if (vm.pSet.rowType == 0) {
        let d = 0
        for (let i = 0; i < vm.pSet.cols.length; i++) {
          if (vm.pSet.cols[i].r == 0) {
            vm.doc.text(vm.pSet.cols[i].l, vm.pSet.horPos + 3, vm.pSet.verPos)
            vm.doc.rect(
              vm.pSet.horPos,
              vm.pSet.verPos - 16,
              0,
              vm.pSet.height - vm.pSet.verPos - 11,
              'S'
            )
            vm.pSet.horPos += vm.pSet.cols[i].w
          }
        }
        vm.doc.rect(
          vm.pSet.horPos,
          vm.pSet.verPos - 16,
          0,
          vm.pSet.height - vm.pSet.verPos - 11,
          'S'
        ) // right vert line

        vm.doc.rect(
          vm.pSet.marginLeft,
          vm.pSet.verPos - 16,
          vm.pSet.horPos - vm.pSet.marginLeft,
          21,
          'S'
        ) // header rect

        vm.doc.rect(
          vm.pSet.marginLeft,
          vm.pSet.height - vm.pSet.marginBottom + 3,
          vm.pSet.horPos -
            vm.pSet.marginLeft /*vm.pSet.width-(2*vm.pSet.marginLeft)+3*/,
          0,
          'S'
        )
      }

      vm.pSet.verPos += 10
      vm.pSet.horPos = vm.pSet.horPos = vm.pSet.marginLeft
    },
    csvMachine(title, header) {
      const vm = this
      if (vm.pSet.rowType < 1) {
        //console.log('vm.pSet.rowType < 1')
        for (let i = 0; i < vm.pSet.cols.length; i++) {
          if (vm.pSet.cols[i].c > 0) {
            vm.pSet.cols[i].cn = vm.pSet.cols[i].c
            if (vm.pSet.cols[i].b >= 0) {
              vm.pSet.cols[i].c = -1 // per evitare doppioni
            }
          } else {
            vm.pSet.cols[i].cn = i
          }
        }
        vm.pSet.cols.sort(function compareCn(a, b) {
          return a.cn - b.cn
        })
        //console.log('cols2', vm.pSet.cols)
      }
      let csv = ''
      if (header.length > 0) {
        header.forEach((element) => {
          if (csv.length > 0) {
            csv += ';'
          }
          csv += element
        })
        csv += '\r\n'
      }
      //console.log(' vm.data.length;', vm.data.length)
      //console.log(' vm.pSet.rowType', vm.pSet.rowType)
      for (let i = 0; i < vm.data.length; i++) {
        switch (vm.pSet.rowType) {
          case 0:
            csv += vm.printCSVRow(vm.data[i])
            break
          case 1:
            csv += vm.printCSVTripRow(vm.data[i])
            break
        }
      }
      vm.downloadCSV(csv, title, 'text/csv;encoding:utf-8')
      vm.isLoading = false
    },

    printerMachine() {
      const vm = this
      vm.doc = new jsPDF(vm.pSet.orientation, 'pt', vm.pSet.pageSize)
      vm.pSet.width = vm.doc.internal.pageSize.getWidth()
      vm.pSet.height = vm.doc.internal.pageSize.getHeight()
      vm.pSet.verPos = vm.pSet.marginTop
      vm.pSet.horPos = vm.pSet.marginLeft
      vm.printTitle()
      vm.doc.setFontSize(vm.pSet.fontSize)
      vm.printHeader()
      for (let i = 0; i < vm.data.length; i++) {
        switch (vm.pSet.rowType) {
          case 0:
            vm.printRow(vm.data[i])
            break
          case 1:
            vm.printTripRow(vm.data[i])
            break
        }
        vm.incrLine()
      }
      vm.uri = vm.doc.output('datauristring')
      vm.isLoading = false
    },
    downloadCSV(content, fileName, mimeType) {
      let a = document.createElement('a')
      mimeType = mimeType || 'application/octet-stream'

      if (navigator.msSaveBlob) {
        // IE10
        navigator.msSaveBlob(
          new Blob([content], {
            type: mimeType,
          }),
          fileName
        )
      } else if (URL && 'download' in a) {
        //html5 A[download]
        a.href = URL.createObjectURL(
          new Blob([content], {
            type: mimeType,
          })
        )
        a.setAttribute('download', fileName)
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      } else {
        location.href =
          'data:application/octet-stream,' + encodeURIComponent(content) // only this mime type is supported
      }
    },

    printTripBars() {
      const vm = this
      let oldref = null
      let dateref = null
      let isCrossDate
      let isResto
      let stopref = null
      let d
      let s
      let kmmin
      vm.doc = new jsPDF('l', 'pt', 'a4')
      let kmtot = 0
      let mntot = 0
      let kmparz = 0
      let mnparz = 0
      let kmcurr = 0
      let mncurr = 0
      let mnstart
      vm.pSet.width = vm.doc.internal.pageSize.getWidth()
      vm.pSet.height = vm.doc.internal.pageSize.getHeight()
      vm.pSet.marginTop = 35
      vm.pSet.marginBottom = 30
      vm.pSet.verPos = vm.pSet.marginTop
      vm.pSet.horPos = (vm.pSet.width - 720) / 2
      let start = vm.newDate(vm.startData).toMysqlString()
      let end = vm.newDate(vm.endData).toMysqlString()
      s =
        'Percorrenza : ' +
        vm.vehicleSel.targa +
        '  dal ' +
        vm.reverseDate(start) +
        ' al ' +
        vm.reverseDate(end)
      vm.autoText(s, vm.pSet.horPos - 8, vm.pSet.verPos, 'left', 'top')
      vm.pSet.verPos += 30

      for (let i = 0; i < vm.data.length; i++) {
        d = vm.newDate(vm.data[i].inizio)
        mnstart = d.getMinutes() + d.getHours() * 60
        dateref = vm.data[i].inizio.slice(0, 10)
        stopref = vm.data[i].fine.slice(0, 10)
        isCrossDate = dateref !== stopref
        if (dateref != oldref) {
          if (oldref !== null) {
            vm.pSet.verPos += 30
            vm.autoText(
              'Tempo Guida : ' + vm.minToString(mnparz),
              vm.pSet.horPos - 8,
              vm.pSet.verPos,
              'left',
              'top'
            )
            vm.autoText(
              'Km  : ' + kmparz,
              vm.pSet.horPos + 100,
              vm.pSet.verPos,
              'left',
              'top'
            )

            kmparz = 0
            mnparz = 0
          }
          vm.pSet.verPos += 30

          if (vm.pSet.verPos + 60 > vm.pSet.height - vm.pSet.marginBottom) {
            vm.doc.addPage()
            vm.pSet.verPos = vm.pSet.marginTop
          }
          vm.drawDayBar(16, vm.reverseDateSolo(dateref))
          if (isResto) {
            mncurr = vm.data[i - 1].minuti - mncurr
            kmcurr = mncurr * kmmin

            vm.drawTrip(0, mncurr)
            kmparz += kmcurr
            mnparz += mncurr
            isResto = false
          }
        }
        if (isCrossDate) {
          mncurr = 1440 - mnstart
          if (vm.data[i].km > 0 && vm.data[i].minuti > 0) {
            kmmin = vm.data[i].km / vm.data[i].minuti
          } else {
            kmmin = 0
          }
          kmcurr = mncurr * kmmin
        } else {
          kmcurr = vm.data[i].km
          mncurr = vm.data[i].minuti
        }
        vm.drawTrip(mnstart, mncurr)
        kmtot += vm.data[i].km
        mntot += vm.data[i].minuti
        kmparz += kmcurr
        mnparz += mncurr
        oldref = dateref
        isResto = isCrossDate
      }
      vm.pSet.verPos += 30
      vm.autoText(
        'Tempo Guida : ' + vm.minToString(mnparz),
        vm.pSet.horPos - 8,
        vm.pSet.verPos,
        'left',
        'top'
      )
      vm.autoText(
        'Km  : ' + kmparz,
        vm.pSet.horPos + 100,
        vm.pSet.verPos,
        'left',
        'top'
      )
      vm.pSet.verPos += 30
      if (vm.pSet.verPos + 20 > vm.pSet.height - vm.pSet.marginBottom) {
        vm.doc.addPage()
        vm.pSet.verPos = vm.pSet.marginTop
      }
      s =
        'Percorrenza : ' + vm.vehicleSel.targa + '  dal ' + start + ' al ' + end
      vm.autoText(s, vm.pSet.horPos - 8, vm.pSet.verPos, 'left', 'top')
      vm.pSet.verPos += 15
      vm.autoText(
        'Totale tempo Guida : ' + vm.minToString(mntot),
        vm.pSet.horPos - 8,
        vm.pSet.verPos,
        'left',
        'top'
      )
      vm.autoText(
        'Totale Km : ' + kmtot,
        vm.pSet.horPos + 120,
        vm.pSet.verPos,
        'left',
        'top'
      )
      vm.uri = vm.doc.output('datauristring')
      vm.isLoading = false
    },
    drawTrip(mnstart, mndurata) {
      const vm = this
      vm.doc.setFillColor(255, 0, 0)
      vm.doc.rect(
        vm.pSet.horPos + mnstart / 2,
        vm.pSet.verPos,
        mndurata / 2,
        5,
        'F'
      ) // right vert line
    },
    drawDayBar(h, theDate) {
      const vm = this
      vm.doc.setFontSize(12)
      vm.autoText(theDate, vm.pSet.horPos - 8, vm.pSet.verPos, 'left', 'top')
      vm.doc.setFontSize(8)
      vm.pSet.verPos += 18
      let b = vm.pSet.verPos + h + 4
      let q = vm.pSet.verPos + (h / 4) * 3
      let ql = h / 4
      let hh = vm.pSet.verPos + h / 2
      let hl = h / 2
      let n = vm.pSet.horPos
      vm.doc.rect(vm.pSet.horPos, vm.pSet.verPos, 720, h, 'S')
      let c = 0
      vm.drawHour(c, vm.pSet.horPos, b)
      c++
      for (let i = 0; i < 47; i++) {
        n += 15
        if (i % 2 == 0) {
          vm.doc.rect(n, q, 0.5, ql, 'S')
        } else {
          vm.doc.rect(n, hh, 0.5, hl, 'S')
          vm.drawHour(c, n, b)
          c++
        }
      }
      n += 15
      vm.drawHour(c, n, b)
    },
    drawHour(hour, offset, verPos) {
      const vm = this
      let s = hour.toString() + '.00'
      vm.autoText(s, offset, verPos, 'center', 'top')
    },
    addTag(newTag) {
      const vm = this
      const tag = {
        segnale: newTag,
        id: vm.tags.length + 1,
      }
      vm.tags.push(tag)
      vm.tagValues.push(tag)
    },
    getWindowHeight(event) {
      const vm = this
      vm.windowHeight = document.documentElement.clientHeight
      document
        .getElementById(vm.vehiclesOpts.id + 'bw')
        .setAttribute('style', 'height:' + (vm.windowHeight - 150) + 'px')
      document
        .getElementById('pdf')
        .setAttribute('style', 'height:' + (vm.windowHeight - 130) + 'px')
      document
        .getElementById('pdfiframe')
        .setAttribute('style', 'height:' + (vm.windowHeight - 130) + 'px')
    },
    beforeDestroy() {
      const vm = this
      window.removeEventListener('resize', vm.getWindowHeight)
    },
  },
}
</script>
